import axios from "axios"

export const login = async (username, password) =>{

    const REACT_APP_ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

    try{

        const response =await axios.post(`${REACT_APP_ADMIN_API_URL}/api/auth/login`, {username, password})
        localStorage.setItem("token", response.data)
        return  { success: true, data: response.data };
    }
    catch(e){
        return {
            success: false,
            error: e.response?.data?.message || "Login failed",
        }
    }

    
}

export const signup = async(username, password, email) => {
    const REACT_APP_ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

    const response = axios.post(`${REACT_APP_ADMIN_API_URL}/api/signup`, {username,password,email})
    return response.data
}